import { render } from "./Simulatore.vue?vue&type=template&id=fcaa1202&scoped=true&ts=true"
import script from "./Simulatore.vue?vue&type=script&lang=ts"
export * from "./Simulatore.vue?vue&type=script&lang=ts"

import "./Simulatore.vue?vue&type=style&index=0&id=fcaa1202&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1764364635178909029/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcaa1202"]])

export default __exports__